/*#########################################################
    フォーム変更時の計算
#########################################################*/

module.exports = {
    // 支払い方法がカードの場合とそれ以外の場合で処理の切り分け
    card_check() {
        const $form = document.pay;
        $form.querySelectorAll('.is-invalid').forEach((elm) => {
            elm.classList.remove('is-invalid');
        });
        // 支払い区分
        const payment_id = document.querySelector('[name="payment_id"]:checked').value;
        // カード以外の場合はそのまま送信
        if (payment_id != 1) {
            $form.submit();
            return false;
        }
        // カードトークンを持っている場合は送信
        if ($form.card_token.value) {
            // 送信先を変更
            $form.action.value = "createToken";
            $form.submit();
            return false;
        }
        // これ以降はカード処理
        make_modal({
            title: "カード問い合わせ中...",
            body: '<div class="text-center"><div class="spinner-grow text-primary m-5" style="width: 3rem; height: 3rem;" role="status"><span class="visually-hidden">Loading...</span></div></div>カードの有効性を確認しています。<br />しばらくお待ちください。',
            mode: "static",
        });
        // コールバック関数(「正常」の場合)
        const createTokenSuccess = function (response) {
            // レスポンスデータの保存
            let formdata = new FormData();
            formdata.append('order_id', $form.order_id.value ?? null);
            formdata.append('returnCode', response.returnCode ?? null);
            formdata.append('token', response.token ?? null);
            formdata.append('response', JSON.stringify(response));
            api({
                api: '/api/user/embeddedTokenLib',
                _method: "POST",
                formdata
            });
            $form.card_token.value = response.token;
            // 正しいカード番号が取得できたので、これ以降はカード番号は不要なのでマスク
            $form.card_no.value = '*'.repeat(Math.max(0, $form.card_no.value.length - 4)) + $form.card_no.value.substr(-4);
            // 入力欄も無効化
            $form.card_no.setAttribute("disabled", true);
            $form.card_owner.setAttribute("disabled", true);
            $form.exp_month.setAttribute("disabled", true);
            $form.exp_year.setAttribute("disabled", true);
            $form.security_code.setAttribute("disabled", true);
            // 送信先を変更
            $form.action.value = "createToken";
            $form.submit();
        };
        // コールバック関数(「異常」の場合)
        const createTokenFailure = function (response) {
            close_modal();
            // レスポンスデータの保存
            let formdata = new FormData();
            formdata.append('order_id', $form.order_id.value ?? null);
            formdata.append('returnCode', response.returnCode ?? null);
            formdata.append('token', response.token ?? null);
            formdata.append('response', JSON.stringify(response));
            api({
                api: '/api/user/embeddedTokenLib',
                _method: "POST",
                formdata
            });
            //エラー情報を取得
            const errorInfo = response.errorInfo;
            function changeColor(errorItem) {
                switch (errorItem) {
                    case "cardNo":
                        document.pay.card_no.classList.add('is-invalid');
                        break;
                    case "cardOwner":
                        document.pay.card_owner.classList.add('is-invalid');
                        break;
                    case "cardExp":
                        document.pay.exp_month.classList.add('is-invalid');
                        document.pay.exp_year.classList.add('is-invalid')
                        break;
                    case "securityCode": document.pay.security_code.classList.add('is-invalid');
                        break;
                }
            }
            let error_body = '<ul class="ms-3 text-danger">';
            //エラーの数だけ処理を繰り返す
            for (var i = 0; i < errorInfo.length; i++) {
                if (errorInfo[i].errorItem) {
                    changeColor(errorInfo[i].errorItem);
                }
                // 出力用メッセージ
                error_body += '<li>' + errorInfo[i].errorMsg + '</li>';
            }
            error_body += '</ul>';
            make_modal({
                title: '<i class="fas fa-exclamation-triangle"></i> 入力内容を確認してください',
                body: error_body,
            })
        };
        const senddata = {
            traderCode: $form.trader_code.value, // 加盟店コード
            authDiv: $form.authDiv.value,
            optServDiv: "01", // 固定値
            memberId: $form.memberId.value,
            authKey: $form.authKey.value,
            checkSum: $form.checkSum.value,
            cardOwner: $form.card_owner.value, // カード名義人
            cardExp: $form.exp_month.value + $form.exp_year.value, // カード有効期限
            securityCode: $form.security_code.value, // セキュリティコード
        };
        if ($form.cardKey.value) { // お預かり情報利用時
            senddata.cardKey = $form.cardKey.value;
            senddata.lastCreditDate = $form.lastCreditDate.value;
        } else { // お預かり情報利用以外
            senddata.cardNo = $form.card_no.value; // カード番号
        }
        WebcollectTokenLib.createToken(senddata, createTokenSuccess, createTokenFailure);
    },
    // 選択肢の描画（支払画面）
    index_showing(cards) {
        if (cards.data.length == 0) { return false; }
        const $box = document.getElementById('card_selector_box');
        const $selector = $box.querySelector('select');
        if (!$selector) { return false; }
        // オプションの描画
        $box.style.display = "block";
        const $form = document.pay;
        cards.data.push({
            cardKey: '',
            maskingCardNo: '新しいカードを登録する',
            cardOwner: '',
            cardExp: '',
            lastCreditDate: '',
        });
        cards.data.forEach((card) => {
            let option = document.createElement('option');
            option.value = card.cardKey;
            option.text = card.maskingCardNo;
            if (card.cardName) {
                option.text += " （" + card.cardName + "）";
            }
            $selector.append(option);
        });
        // オプションの最初の選択値をフォームにセット
        payment.set_form(cards.data, $selector);
        // オプションが変更されたらフォームにセット
        $selector.addEventListener('change', function () {
            payment.set_form(cards.data, this);
        });
    },
    // 選択肢の描画（マイページ）
    list_showing(cards) {
        if(cards.error){
            (async (cards) => {
                // awaitを使うと、なぜかmodalが表示されないので、一旦コメントアウト
                // await close_modal();
                close_modal();
                make_modal({
                    title: 'エラー',
                    body: 'エラーが発生しました。<br />' + cards.messageText.replace(/\\n/g,'<br>') ,
                });
            })(cards);
        }
        if (cards.data.length == 0) { return false; }
        const $target_body = document.getElementById('target_body');
        $target_body.innerHTML = "";
        if (cards.data.length == 0) {
            const template_notfound = getCloneNode(document.getElementById('template_notfound'));
            $target_body.appendChild(template_notfound.cloneNode(true));
            return false;
        }
        const template_body = getCloneNode(document.getElementById('template_body'));
        const template_header = getCloneNode(document.getElementById('template_header'));
        $target_body.appendChild(template_header.cloneNode(true));
        cards.data.forEach((card) => {
            template_body.querySelector('[data-content="maskingCardNo"]').innerHTML = card.maskingCardNo;
            if (card.cardExp) {
                template_body.querySelector('[data-content="cardExp"]').innerHTML = card.cardExp.substr(0, 2) + "/" + card.cardExp.substr(2, 2);
            }
            template_body.querySelector('[data-content="cardName"]').innerHTML = card.cardName;
            template_body.querySelector('[data-content="delete"]').setAttribute('data-id', card.cardKey);
            $target_body.appendChild(template_body.cloneNode(true));
        });
        // 追加したボタンに削除イベントを追加
        $target_body.querySelectorAll('[data-content="delete"]').forEach((btn) => {
            btn.addEventListener('click', function () {
                const id = this.getAttribute('data-id');
                const card = cards.data.find((card) => {
                    return card.cardKey == id;
                });
                payment.delete_showing(card);
            });
        });
    },
    // 支払データの削除用表示
    delete_showing(card) {
        if (card.cardExp) {
            card.cardExp = card.cardExp.substr(0, 2) + "/" + card.cardExp.substr(2, 2);
        }
        const title = `<i class="far fa-trash-alt"></i> 削除しますか？`;
        const body = setTextHtml('template_del', card);
        const footer =
            `<button type="button" class="btn btn-danger btn-shadow px-4 px-md-5" data-content="destroy">
            <i class="far fa-trash-alt"></i> 削除する
        </button>`;
        make_modal({ title, body, footer });
        document.getElementById('modal').querySelector('[data-content="destroy"]').addEventListener('click', function () {
            (async (card) => {
                await close_modal();
                payment.destroy(card);
            })(card);
        });
    },
    //支払いデータの削除
    destroy(card) {
        make_modal({
            title: "カード情報削除中...",
            body: '<div class="text-center"><div class="spinner-grow text-primary m-5" style="width: 3rem; height: 3rem;" role="status"><span class="visually-hidden">Loading...</span></div></div>登録されているカードの情報を削除しています。<br />しばらくお待ちください。',
            mode: "static",
        });
        let formdata = new FormData();
        formdata.append('card', JSON.stringify(card));
        formdata.append('mode', 'delete');
        api({
            api: '/api/user/creditInfo',
            _method: "POST",
            formdata,
            callback: payment.list_showing,
            e_callback: payment.list_showing,
        });
    },
    // フォームに値をセット（支払画面）
    set_form(cards, $selector) {
        const $form = document.pay;
        const value = $selector.value;
        const card = cards.find((card) => card.cardKey == value);
        if (value) {
            $form.card_no.value = card.maskingCardNo;
            $form.card_owner.value = card.cardOwner;
            $form.exp_month.value = card.cardExp.substr(0, 2);
            $form.exp_year.value = card.cardExp.substr(2, 2);
            $form.lastCreditDate.value = card.lastCreditDate;
            $form.card_no.setAttribute("disabled", true);
            $form.card_owner.setAttribute("disabled", true);
            $form.exp_month.setAttribute("disabled", true);
            $form.exp_year.setAttribute("disabled", true);
        } else {
            $form.card_no.value = '';
            $form.exp_month.value = '';
            $form.exp_year.value = '';
            $form.card_owner.value = '';
            $form.lastCreditDate.value = '';
            $form.card_no.removeAttribute("disabled");
            $form.card_owner.removeAttribute("disabled");
            $form.exp_month.removeAttribute("disabled");
            $form.exp_year.removeAttribute("disabled");
        }
    }
}